import clsx from 'clsx';
import getLocale from '../../../hooks/getLocale';
import {SanityHeroDefault} from '../../../types';
import SanityImage from '../../media/SanityImage.client';
import sanityConfig from '../../../../sanity.config';

type Props = {
  hero: SanityHeroDefault;
};

export default function HeroSplit({hero}: Props) {
  return (
    <div
      key={hero._key}
      className={clsx(
        'hero-split',
        'flex h-full w-full flex-col',
        'grid-cols-1 bg-bg-blue md:grid md:grid-cols-2 md:items-center md:justify-start',
      )}
    >
      <div
        className={clsx(
          'flex h-full flex-col justify-center bg-black px-4 py-12',
          'sm:px-12 md:py-0',
        )}
      >
        <div className={'2xl:m-auto 2xl:max-w-[768px]'}>
          {/* Title */}
          {hero.title && (
            <h1
              className={clsx(
                'h1 mb-7 whitespace-pre-line text-left font-industry font-bold text-white',
              )}
            >
              {typeof hero.title === 'object'
                ? getLocale(hero.title)
                : hero.title}
            </h1>
          )}
          {/* Text */}
          {hero.text && (
            <p className={clsx('p text-white')}>
              {typeof hero.text === 'object' ? getLocale(hero.text) : hero.text}
            </p>
          )}
        </div>
      </div>
      {hero.image && (
        <picture
          className={clsx(
            'relative h-full', //,
          )}
        >
          <SanityImage
            alt={hero.image?.altText}
            crop={hero.image?.crop}
            dataset={sanityConfig.dataset}
            hotspot={hero.image?.hotspot}
            projectId={sanityConfig.projectId}
            src={hero.image?.asset._ref}
            layout="responsive"
            className={clsx('absolute h-full object-cover')}
            objectFit="cover"
            sizes="100vw"
          />
        </picture>
      )}
    </div>
  );
}
